import { render, staticRenderFns } from "./ed-material-viewer.vue?vue&type=template&id=3932f1b6&"
import script from "./ed-material-viewer.ts?vue&type=script&lang=ts&"
export * from "./ed-material-viewer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports